export const PILOT_DATA_FRAMES_CARD_FRENCH_LOCALE = {
  title: "Logs du pilote",
};
